import React from "react";

const FilterIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 17 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="current"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 6h15M1 1h15M1 11h10"
    />
  </svg>
);

export default FilterIcon;
